// Vuex transaction module actions
import { togglePendingStoreActions } from '@/utils/decorators';
import { API } from '@/config';

import { FILL_DETAILS } from './mutations-types';

export default {
  async getDetails({ commit }, user) {
    try {
      const params = { user };
      const { record, total } = (await API.get('/user/getDetails', { params })).data.data;
      commit(FILL_DETAILS, { record, total });
    } catch (err) {
      console.log(err);
    }
  },
  async updateUser(context, params) {
    try {
      return await API.patch('/user/updateUser', { ...params });
    } catch (err) {
      console.log(err);
    }
  },
  async createUser(contex, params) {
    try {
      await API.put('/user/createUser', { ...params });
    } catch (err) {
      console.log(err);
    }
  },
  async deleteUser(contex, user) {
    try {
      const params = { user };
      await API.delete('/user/deleteUser', { params });
      return;
    } catch (err) {
      console.log(err);
    }
  },
  async uploadAvatar(_context, params) {
    try {
      const formData = new FormData();
      formData.append('avatar', params.avatar);
      return (await API.post('/user/uploadAvatar', formData)).data.data;
    } catch (err) {
      console.log(err);
    }
  },
};
